import { useNavigate }      from 'react-router-dom';
import { NavigateFunction } from 'react-router-dom';
import { useParams }        from 'react-router-dom';
import { useLocation }      from 'react-router-dom';
import { Location }         from 'react-router-dom';
import { Params }           from 'react-router-dom';
import React                from 'react';

export interface WithNavigationProps {
  navigate: NavigateFunction;
  location: Location;
  params: Params<string>;
}

export function withNavigation<P extends WithNavigationProps>(
  Component: React.ComponentType<P>
) {
  return function WithNavigationWrapper(props: Omit<P, keyof WithNavigationProps>) {
    const navigate = useNavigate();
    const params = useParams();
    const location = useLocation();

    return (
      <Component
        {...(props as P)}
        navigate={navigate}
        params={params}
        location={location}
      />
    );
  };
}